import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import ExaminationsRs, { ExaminationGradesRs } from '@domain/rs/profile/skill/ExaminationRs';

const examinationsPrefix = '/examinations';

export default interface ExaminationsRepo {
  //어학시험  목록 조회
  fetchExaminations(keyword: string): Promise<AxiosResponse<ExaminationsRs>>;

  //어학시험  등급 목록 조회
  fetchExaminationGrades(code: number): Promise<AxiosResponse<ExaminationGradesRs>>;
}

export class RemoteExaminationsRepo implements ExaminationsRepo {
  fetchExaminations(keyword: string) {
    return axios.get<ExaminationsRs>(`${examinationsPrefix}`, { params: { keyword } });
  }

  fetchExaminationGrades(code: number) {
    return axios.get<ExaminationGradesRs>(`${examinationsPrefix}/${code}/grades`);
  }
}
